/*
    CAUTION: PLEASE READ! This File was auto generated by the system.
    Any changes you make will be removed the next time it's generated.
*/
import {
ExternalAppItemService         
,ExternalAppSettingItemService         
,AIPromptItemService         
,ConvokeAppConfigItemService         
,DataTypeItemService         
,EntityMasterRecordItemService         
,EntityMasterRecordMapItemService         
,EntityObjectFieldMapItemService         
,EntityObjectItemService         
,EntityQueryItemService         
,SchemaItemService         
,IntegrationItemService         
,SourceObjectItemService         
,SourceQueryItemService
,SourceObjectRecordItemService         
,SourceSystemItemService         
,DirtyRecordDeploymentItemService         
,SchemaAPIItemService         
,SchemaDestinationLogItemService         
,WarehouseItemService         
,AIAnalyticsItemService         
,AIChatItemService         
,AIChatSessionItemService         
,SageCustomerItemService   
,FileStorageItemService      
,SageVendorItemService} from './ItemServices';
import {ItemServiceFactory as BaseItemServiceFactory} from 'spark-core-dx/services'

export class ItemServiceFactory {

get ItemServiceEnum() {
  return {
      ...BaseItemServiceFactory.ItemServiceEnum,
    ExternalApp:"ExternalApp",
    ExternalAppSetting:"ExternalAppSetting",
    AIPrompt:"AIPrompt",
    ConvokeAppConfig:"ConvokeAppConfig",
    DataType:"DataType",
    EntityMasterRecord:"EntityMasterRecord",
    EntityMasterRecordMap:"EntityMasterRecordMap",
    EntityObjectFieldMap:"EntityObjectFieldMap",
    EntityObject:"EntityObject",
    EntityQuery:"EntityQuery",
    Schema:"Schema",
    Integration:"Integration",
    SourceObject:"SourceObject",
    SourceQuery:"SourceQuery",
    SourceObjectRecord:"SourceObjectRecord",
    SourceSystem:"SourceSystem",
    DirtyRecordDeployment:"DirtyRecordDeployment",
    SchemaAPI:"SchemaAPI",
    SchemaDestinationLog:"SchemaDestinationLog",
    Warehouse:"Warehouse",
    AIAnalytics:"AIAnalytics",
    AIChat:"AIChat",
    AIChatSession:"AIChatSession",
    SageCustomer:"SageCustomer",
    SageVendor:"SageVendor",
    FileStorage:"FileStorage"
  }
}

GetItemService(itemServiceName, coreState, coreContext, isWarning) {
    if(itemServiceName === undefined) throw new Error('Item service name not found, please regenerate the Item Services to resolve this issue.');
    let itemService;
    switch(itemServiceName.toLowerCase()){
        case this.ItemServiceEnum.ExternalApp.toLowerCase():
             itemService = new ExternalAppItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalAppSetting.toLowerCase():
             itemService = new ExternalAppSettingItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIPrompt.toLowerCase():
             itemService = new AIPromptItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ConvokeAppConfig.toLowerCase():
             itemService = new ConvokeAppConfigItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataType.toLowerCase():
             itemService = new DataTypeItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityMasterRecord.toLowerCase():
             itemService = new EntityMasterRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityMasterRecordMap.toLowerCase():
             itemService = new EntityMasterRecordMapItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityObjectFieldMap.toLowerCase():
             itemService = new EntityObjectFieldMapItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityObject.toLowerCase():
             itemService = new EntityObjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityQuery.toLowerCase():
             itemService = new EntityQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Schema.toLowerCase():
             itemService = new SchemaItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Integration.toLowerCase():
             itemService = new IntegrationItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceObject.toLowerCase():
             itemService = new SourceObjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceQuery.toLowerCase():
             itemService = new SourceQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceObjectRecord.toLowerCase():
             itemService = new SourceObjectRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceSystem.toLowerCase():
             itemService = new SourceSystemItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DirtyRecordDeployment.toLowerCase():
             itemService = new DirtyRecordDeploymentItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SchemaAPI.toLowerCase():
             itemService = new SchemaAPIItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SchemaDestinationLog.toLowerCase():
             itemService = new SchemaDestinationLogItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Warehouse.toLowerCase():
             itemService = new WarehouseItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIAnalytics.toLowerCase():
             itemService = new AIAnalyticsItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChat.toLowerCase():
             itemService = new AIChatItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChatSession.toLowerCase():
             itemService = new AIChatSessionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SageCustomer.toLowerCase():
             itemService = new SageCustomerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SageVendor.toLowerCase():
             itemService = new SageVendorItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.FileStorage.toLowerCase():
             itemService = new FileStorageItemService(coreState, coreContext, isWarning);
             break;
        default:
            itemService = BaseItemServiceFactory.GetItemService(itemServiceName, coreState, coreContext);
            break;
        }
        return itemService;
    }

ValidateItemName(itemName) {
    let isValid = false;
    for (const key in this.ItemServiceEnum){
        if (typeof(this.ItemServiceEnum[key]) === "string" &&
                this.ItemServiceEnum[key].toLowerCase() == itemName.toLowerCase())
                {
                    isValid = true;
                    break;
                }
        }
     return BaseItemServiceFactory.ValidateItemName(itemName);
 }
}
